import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListChecks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m3 17 2 2 4-4" }),
		/* @__PURE__ */ _jsx("path", { d: "m3 7 2 2 4-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 6h8" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 12h8" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 18h8" })
	]
});
export default SvgListChecks;
